module.exports = __webpack_public_path__ + "img/log.c5244b27.svg";